import { Pipe, PipeTransform } from '@angular/core';

import { Question } from '../models/question.model';

@Pipe({
  name: 'qType',
  pure: true
})
export class QuestionTypePipe implements PipeTransform {
  transform(qId: string, questions: Question[]): string {
    return questions.find((q) => q.id === qId)?.type;
  }
}
